import 'css-chunksrc/client/pages/planzoneParametersPage/resourceUsageReport/styles.scss';export default {
  "wbsReport": "_wbsReport_18cdi_1",
  "checked": "_checked_18cdi_7",
  "row": "_row_18cdi_11",
  "checkbox": "_checkbox_18cdi_20",
  "col": "_col_18cdi_26",
  "name": "_name_18cdi_30",
  "description": "_description_18cdi_37",
  "filters": "_filters_18cdi_42",
  "group": "_group_18cdi_51",
  "label": "_label_18cdi_60",
  "button": "_button_18cdi_67"
};